import { locales, defaultLocale } from '../translations/i18nConfig';

const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://aliens-exist.de'
).replace(/\/$/, '');

// Absolute URL of a story in a given locale. The "home" story is served at
// the locale root, so /home and /en/home are never exposed as URLs.
export const localizedUrl = (slug: string, locale: string): string => {
  const path = slug === 'home' ? '' : `/${slug.replace(/^\/|\/$/g, '')}`;
  const prefix = locale === defaultLocale ? '' : `/${locale}`;
  return `${SITE_URL}${prefix}${path || (prefix ? '' : '/')}`;
};

// One entry per configured locale, used for hreflang alternates
export const alternateUrls = (slug: string) =>
  locales.map((locale) => ({ locale, href: localizedUrl(slug, locale) }));
